import ApiService from '@/services/core/api.service'

const BusinessPartnerDraftService = {
  async get (query = '') {
    return ApiService.get(`user/business-partners?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/business-partners', payload)
  },

  async put (payload) {
    return ApiService.put(`user/business-partners/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/business-partners/${payload.id}`, {
      data: payload
    })
  }
}

export default BusinessPartnerDraftService
